export const GET_ROOM_LABELS = 'GET_ROOM_LABELS'
export const GET_SUBSCRIPTION_LABELS = 'GET_SUBSCRIPTION_LABELS'
export const GET_DATA_ROOM_PRICING = 'GET_DATA_ROOM_PRICING'
export const GET_DATA_ROOM_CUSTOM_PRICING = 'GET_DATA_ROOM_CUSTOM_PRICING'
export const GET_PM_ROOMS_PROGRESSIVELY = 'GET_PM_ROOMS_PROGRESSIVELY'
export const GET_PM_ROOMS = 'GET_PM_ROOMS'
export const GET_GUEST_ROOMS_PROGRESSIVELY = 'GET_GUEST_ROOMS_PROGRESSIVELY'
export const GET_GUEST_ROOMS = 'GET_GUEST_ROOMS'
export const GET_EXISTING_ROOMS_LABELS = 'GET_EXISTING_ROOMS_LABELS'
export const GET_LAST_VISITED_ROOMS = 'GET_LAST_VISITED_ROOMS'
export const GET_RECENT_ROOMS = 'GET_RECENT_ROOMS'
